import { VersionUpdateBanner } from 'components/common/VersionUpdateBanner';
import { LocalizationContext } from 'localization/LocalizationContext';
import { Router } from 'router';
import {
  PosthogProvider,
  AuthProvider,
  ApiInterceptorProvider,
  TanstackQueryProvider,
  SnackbarProvider,
  AntdProvider,
  MuiProvider,
} from './providers';

export const App = () => {
  return (
    <PosthogProvider>
      <AuthProvider>
        <ApiInterceptorProvider>
          <TanstackQueryProvider>
            <MuiProvider>
              <LocalizationContext>
                <SnackbarProvider>
                  <AntdProvider>
                    <VersionUpdateBanner />
                    <Router />
                  </AntdProvider>
                </SnackbarProvider>
              </LocalizationContext>
            </MuiProvider>
          </TanstackQueryProvider>
        </ApiInterceptorProvider>
      </AuthProvider>
    </PosthogProvider>
  );
};
